(function() {
    angular
        .module('Order4meBase', ['ngStorage']);
})();